import { useLingui } from "@lingui/react/macro";
import { XCircle } from "lucide-react";
import { Button } from "@/components/ui/button";

interface MediaCardProps {
  url: string;
  onRemove: () => void;
}

export function MediaCard({ url, onRemove }: MediaCardProps) {
  const { t } = useLingui();
  const filename = url.split("/").pop() ?? url;

  return (
    <div className="flex items-center justify-between rounded-[10px] border border-(--color-border) bg-(--color-surface-muted) p-3">
      <div className="flex items-center gap-3">
        <div className="size-14 shrink-0 overflow-hidden rounded-[10px] bg-(--color-surface-muted)">
          <img src={url} alt={filename} className="size-full object-cover" />
        </div>
        <p className="text-sm font-medium text-(--color-text-primary)">{filename}</p>
      </div>
      <Button
        type="button"
        variant="destructive-subtle"
        size="sm"
        className="h-10 gap-2"
        onClick={onRemove}
      >
        <XCircle className="size-5" />
        {t`Remove`}
      </Button>
    </div>
  );
}
